module.exports = __webpack_public_path__ + "media/components/sidebar/logo/login-ac26961292f9722c6330b2c3dd5bce03.png";